// Capabilities stay in memory and are sent in the first TLS websocket frame,
// never in URLs, storage, analytics or a third-party service.
export async function connectSupport({ api, base, id, onMessage, onClose, WebSocketImpl = WebSocket }) {
  const { data } = await api.post(`${base}/requests/${id}/ticket`, {});
  const url = new URL(data.data.path, new URL(api.defaults?.baseURL || window.location.origin, window.location.origin));
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  const socket = new WebSocketImpl(url.href);
  let stopped = false, awaiting = false, queuedBytes = 0, ackTimer, heartbeat;
  const connectTimer = setTimeout(close, 10000);
  const queue = [];
  function close() {
    if (stopped) return;
    stopped = true; queue.length = 0; queuedBytes = 0;
    clearTimeout(connectTimer); clearTimeout(ackTimer); clearInterval(heartbeat);
    socket.close(); onClose?.();
  }
  function pump() {
    if (stopped || awaiting || socket.readyState !== 1 || !queue.length) return;
    const value = queue.shift(); queuedBytes -= value.length;
    awaiting = true; socket.send(value);
    ackTimer = setTimeout(close, 8000);
  }
  socket.onopen = () => { if (!stopped) socket.send(JSON.stringify({ type: 'authenticate', ticket: data.data.ticket })); };
  socket.onerror = close; socket.onclose = close;
  socket.onmessage = event => {
    if (stopped) return;
    try {
      const message = JSON.parse(event.data);
      if (message.type === 'ack') { awaiting = false; clearTimeout(ackTimer); pump(); return; }
      if (message.type === 'ready') {
        clearTimeout(connectTimer);
        if (heartbeat) throw new Error('Unexpected handshake');
        heartbeat = setInterval(async () => {
          try { await api.get(`${base}/requests/${id}`, { timeout: 5000 }); }
          catch { close(); }
        }, 8000);
      }
      onMessage(message);
    } catch { close(); }
  };
  return { close, send(message) {
    if (stopped) return;
    const value = JSON.stringify(message);
    // UTF-8 may take four bytes per JS character; enforce the byte limit too.
    if (new TextEncoder().encode(value).length > 4 * 1024 * 1024 || queuedBytes + value.length > 4 * 1024 * 1024) { close(); return; }
    queuedBytes += value.length; queue.push(value); pump();
  } };
}
